import { render, staticRenderFns } from "./LegendPrognose.vue?vue&type=template&id=37d7cc31&scoped=true"
import script from "./LegendPrognose.vue?vue&type=script&lang=js"
export * from "./LegendPrognose.vue?vue&type=script&lang=js"
import style0 from "./LegendPrognose.vue?vue&type=style&index=0&id=37d7cc31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d7cc31",
  null
  
)

export default component.exports